import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { getAccountStatus } from "../apis/apis";

const ReturnHandler = () => {
  const { accountId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccountStatus = async () => {
      try {
        const response = await getAccountStatus(accountId);
        console.log("Account status response:", response);
        
        if (response.data.chargesEnabled) {
          navigate("/settings");
        } else {
          navigate(`/settings/${accountId}`);
        }
      } catch (error) {
        console.error("Error checking account status:", error);
        navigate("/error");
      }
    };

    checkAccountStatus();
  }, [accountId, navigate]);

  return <div>Checking your account status...</div>;
};

export default ReturnHandler;
